import { Injectable } from '@angular/core';
import { switchMap, tap } from 'rxjs/operators';
import { SwUpdate } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material';
import { interval } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { LifeCycleService } from '../life-cycle/life-cycle.service';

@Injectable({ providedIn: 'root' })
export class CheckForUpdateService {
  constructor(
    public lifeCycle: LifeCycleService,
    public updates: SwUpdate,
    public snackBar: MatSnackBar,
    public logger: NGXLogger
  ) {}

  public start() {
    this.logger.info('[CheckForUpdateService] start');
    if (this.updates.isEnabled) {
      this.updates.activated.subscribe(() => {
        this.snackBar.open('Ein Update wurde installiert', 'ok');
        this.logger.info(
          '[CheckForUpdateService] Ein Update wurde installiert'
        );
      });
      this.lifeCycle.appIsReady$
        .pipe(
          switchMap(() => this.updates.available),
          tap(() =>
            this.snackBar.open('Ein neues Update steht zur VerfÃ¼gung!', 'ok')
          ),
          tap(() => this.updates.activateUpdate()),
          tap(() =>
            this.logger.info(
              '[CheckForUpdateService] Ein neues Update steht zur VerfÃ¼gung!'
            )
          )
        )
        .subscribe();
      this.lifeCycle.appIsReady$
        .pipe(
          tap(() => this.updates.checkForUpdate()),
          tap(() =>
            this.logger.info('[CheckForUpdateService] check for updates')
          )
        )
        .subscribe();
      this.lifeCycle
        .whenReady(() =>
          interval(1000 * 60 * 60).pipe(
            tap(() => this.updates.checkForUpdate()),
            tap(() =>
              this.logger.info('[CheckForUpdateService] check for updates')
            )
          )
        )
        .subscribe();
    } else {
      this.logger.warn('[CheckForUpdateService] ServiceWorker disabled');
      this;
    }
  }
}
